/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Recording_CompleteInputs */

const en_audio_recorder_recording_complete = /** @type {(inputs: Audio_Recorder_Recording_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recording complete! You can preview or save your recording.`)
};

const fr_audio_recorder_recording_complete = /** @type {(inputs: Audio_Recorder_Recording_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement terminé ! Vous pouvez prévisualiser ou sauvegarder votre enregistrement.`)
};

const de_audio_recorder_recording_complete = /** @type {(inputs: Audio_Recorder_Recording_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahme abgeschlossen! Sie können Ihre Aufnahme in der Vorschau ansehen oder speichern.`)
};

const it_audio_recorder_recording_complete = /** @type {(inputs: Audio_Recorder_Recording_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione completata! Puoi visualizzare in anteprima o salvare la registrazione.`)
};

const ru_audio_recorder_recording_complete = /** @type {(inputs: Audio_Recorder_Recording_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись завершена! Вы можете прослушать или сохранить запись.`)
};

const es_audio_recorder_recording_complete = /** @type {(inputs: Audio_Recorder_Recording_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Grabación completa! Puedes previsualizar o guardar la grabación.`)
};

const zh_cn2_audio_recorder_recording_complete = /** @type {(inputs: Audio_Recorder_Recording_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录制完成！您可以预览或保存录制内容。`)
};

const ja_audio_recorder_recording_complete = /** @type {(inputs: Audio_Recorder_Recording_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`録音が完了しました。録音内容をプレビューしたり保存したりできます。`)
};

const hi_audio_recorder_recording_complete = /** @type {(inputs: Audio_Recorder_Recording_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्डिंग पूरी हुई! आप अपनी रिकॉर्डिंग का पूर्वावलोकन कर सकते हैं या उसे सहेज सकते हैं।`)
};

const pt_pt2_audio_recorder_recording_complete = /** @type {(inputs: Audio_Recorder_Recording_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravação concluída! Você pode pré-visualizar ou salvar sua gravação.`)
};

/**
* | output |
* | --- |
* | "Recording complete! You can preview or save your recording." |
*
* @param {Audio_Recorder_Recording_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_recording_complete = /** @type {((inputs?: Audio_Recorder_Recording_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Recording_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_recording_complete(inputs)
	if (locale === "de") return de_audio_recorder_recording_complete(inputs)
	if (locale === "it") return it_audio_recorder_recording_complete(inputs)
	if (locale === "ru") return ru_audio_recorder_recording_complete(inputs)
	if (locale === "es") return es_audio_recorder_recording_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_recording_complete(inputs)
	if (locale === "ja") return ja_audio_recorder_recording_complete(inputs)
	if (locale === "hi") return hi_audio_recorder_recording_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_recording_complete(inputs)
	return en_audio_recorder_recording_complete(inputs)
});